import React, { useState, useEffect } from "react";
import { Button, ButtonType } from "~/components/elements/buttons/Button";
import { IconType } from "~/components/elements/Icon";
import Image from "~/components/elements/Image";
import ContactForm from "~/components/flexible/ContactForm";

const WhitepapersPodcastsHero = (props) => {
	const { title, article } = props;

	const fileLink = article?.whitepaper?.file?.localFile?.publicURL;
	const isGated = article?.whitepaper?.isGated;

	const [showGatedForm, setShowGatedForm] = useState(false);
	const [scrollPosition, setScrollPosition] = useState(0);

	// Close gated form on escape key
	useEffect(() => {
		const handleEscapeKey = (event) => {
			if (event.key === "Escape" && showGatedForm) {
				setShowGatedForm(false);
			}
		};

		document.addEventListener("keydown", handleEscapeKey);

		return () => {
			document.removeEventListener("keydown", handleEscapeKey);
		};
	}, [showGatedForm]);

	// Prevent body scrolling when modal is open
	// Body overflow hidden doesn't work
	useEffect(() => {
		if (showGatedForm) {
			setScrollPosition(window.scrollY);
			document.body.style.position = "fixed";
			document.body.style.top = `-${window.scrollY}px`;
			document.body.style.width = "100%";
		} else {
			document.body.style.position = "";
			document.body.style.top = "";
			document.body.style.width = "";
			window.scrollTo(0, scrollPosition);
		}

		return () => {
			document.body.style.position = "";
			document.body.style.top = "";
			document.body.style.width = "";
		};
	}, [showGatedForm, scrollPosition]);

	const gatedFormButtonHandler = () => {
		setShowGatedForm(true);
	};

	const closeGatedFormHandler = () => {
		setShowGatedForm(false);
	};

	return (
		<div className="mb-24 grid grid-cols-12">
			<div className="col-span-12 lg:col-span-8">
				{/* Title */}
				<h1 className="text-h3 mb-10 !font-body">{title}</h1>

				{/* Download CTA */}
				{/* Non gated */}
				{!!fileLink && (
					<>
						{isGated ? (
							<Button
								link={{ title: "Download" }}
								onClick={gatedFormButtonHandler}
								icon={IconType.ArrowRightDown}
								type={ButtonType.Button}
								// noGatsbyLink
								// noLink
							/>
						) : (
							<Button link={{ url: fileLink, title: "Download" }} icon={IconType.ArrowRightDown} type={ButtonType.Button} noGatsbyLink newTab />
						)}
					</>
				)}
				{/* {!!fileLink && <Button link={{ url: fileLink, title: "Download" }} icon={IconType.ArrowRightDown} type={ButtonType.Button} noGatsbyLink newTab />} */}

				{/* Gated */}
				{showGatedForm && (
					<div className="fixed inset-0 z-[999] flex h-[100dvh] w-[100dvw] items-center justify-center !bg-black/60 p-6">
						<div className="relative flex max-h-[80dvh] justify-center overflow-y-auto rounded-xl bg-white p-6 text-black md:max-h-[85dvh] md:p-10">
							<button
								onClick={closeGatedFormHandler}
								className="bg-gray-100 hover:bg-gray-200 absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full"
								aria-label="Close form"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="25"
									height="25"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<line x1="18" y1="6" x2="6" y2="18"></line>
									<line x1="6" y1="6" x2="18" y2="18"></line>
								</svg>
							</button>
							<ContactForm
								containerClasses="py-10 px-0 -mt-9"
								disableHeadingMargin
								headingClasses="my-10"
								onSubmitSuccess={() => {
									if (fileLink) {
										window.open(fileLink, "_blank");
									}
								}}
							/>
						</div>
					</div>
				)}
			</div>

			{/* Image */}
			<div className="col-span-12 mt-8 lg:col-span-3 lg:col-start-10 lg:mt-0">
				<Image image={article.image} />
			</div>
		</div>
	);
};

export default WhitepapersPodcastsHero;
